import { ButtonTW } from '../../../../../../tailwindComponents/buttonTW/ButtonTW';
import { UserPlusIcon } from '@heroicons/react/24/outline';
import { BodyTextTW } from '../../../../../../tailwindComponents/bodyText/BodyTextTW';
import React from 'react';

const iconClassNames = 'mr-1 h-5 w-5';

export const AddSignatoriesButton = ({ onAddSignatoriesClick }: { onAddSignatoriesClick: () => void }) => (
  <div className={'mt-4'}>
    <ButtonTW data-test-id={'add-signer-button'} secondary onClick={onAddSignatoriesClick}>
      <div className={'flex justify-start align-middle'}>
        <UserPlusIcon className={iconClassNames} />
        <BodyTextTW>Add Attendee</BodyTextTW>
      </div>
    </ButtonTW>
  </div>
);
